var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"current-time",class:_vm.getThemeClass()},[_vm._v("\n    "+_vm._s(_vm.currentTime)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }